import React, {Component} from 'react'
import {Spin} from "antd";
import JobTableHead from "./table/JobTableHead"
import JobTableBody from "./table/JobTableBody"

class JobsTable extends Component {

    render() {
        const {listSession, loading, reloadListSessions} = this.props

        return (
            <div className="JobTable">
                <Spin spinning={loading} tip={'Đang lấy dữ liệu từ server...'}>
                    <table className='table'>
                        <JobTableHead/>
                        <JobTableBody listSession={listSession} reloadListSessions={reloadListSessions}/>
                    </table>
                </Spin>
            </div>
        )
    }

}

export default JobsTable